import styled from 'styled-components';

export const Container = styled.section`
  align-items: center;
  background: linear-gradient(to top, #0f1513 0%, #3e3e3e 100%);
  display: flex;
  font-family: 'Ciutadella', system-ui;
  font-size: 60px;
  font-weight: bold;
  height: 82px;
  zoom: ${({ isBuilder }) => (isBuilder ? '0.7' : 'normal')};
`;
Container.displayName = 'Container';

export const Fault = styled.div`
  background-color: ${({ active, index }) =>
    active ? (index === 4 ? '#D0333A' : '#FF9E1A') : '#959595'};
  height: 3px;
  margin: 0 2px;
  width: 24px;
`;
Fault.displayName = 'Fault';

const FaultsContainer = styled.div`
  bottom: -6px;
  display: flex;
  justify-content: center;
  margin-top: 8px;
  position: absolute;
`;
FaultsContainer.displayName = 'FaultsContainer';

export const FaultsContainerLeft = styled(FaultsContainer)`
  right: 6px;
`;
FaultsContainer.displayName = 'FaultsContainer';

export const FaultsContainerRight = styled(FaultsContainer)`
  left: 6px;
`;
FaultsContainer.displayName = 'FaultsContainer';

export const FaultsPointsContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: relative;
`;
FaultsPointsContainer.displayName = 'FaultsPointsContainer';

export const Logo = styled.img`
  width: 180px;
`;
Logo.displayName = 'Logo';

export const LogoContainer = styled.div`
  align-content: center;
  background: linear-gradient(to right, #d6d6d6 0%, #ffffef 50%, #d6d6d6 100%);
  display: flex;
  justify-content: center;
  height: 100%;
  width: 246px;
`;
LogoContainer.displayName = 'LogoContainer';

export const Points = styled.div`
  line-height: 52px;
  min-width: 120px;
`;
Points.displayName = 'Points';

export const PointsContainer = styled.div`
  align-items: center;
  color: #fff;
  display: flex;
  font-weight: bold;
  justify-content: center;
  min-width: 96px;
  text-align: center;
`;
PointsContainer.displayName = 'PointsContainer';

export const QuarterTime = styled.div`
  align-items: center;
  color: #fff;
  display: flex;
  font-size: 38px;
  font-weight: 300;
  justify-content: center;
  min-width: 68px;
  text-align: center;
`;
QuarterTime.displayName = 'QuarterTime';

export const Separator = styled.div`
  background: #3b3f3d;
  height: 50px;
  position: relative;
  top: -6px;
  width: 2px;
`;
Separator.displayName = 'Separator';

export const TeamName = styled.div`
  align-items: center;
  background-color: #ffffff;
  color: #000000;
  display: flex;
  justify-content: center;
  height: 100%;
  min-width: 120px;
  padding: 0 8px;
  text-align: center;
`;
TeamName.displayName = 'TeamName';

export const Timer = styled.div`
  align-items: center;
  color: #fff;
  display: flex;
  font-size: 38px;
  font-weight: 300;
  justify-content: center;
  min-width: 110px;
  text-align: center;
`;
Timer.displayName = 'Timer';
